import { Container } from "pixi.js"

export let boardContainer = new Container();




let scale = window.innerHeight > 667 ? 1 : window.innerHeight / 667
boardContainer.width = 315
boardContainer.height = 360
boardContainer.x = window.innerWidth / 2
boardContainer.y = window.innerHeight / 2 - (100 * scale);
boardContainer.scale.set(scale)
boardContainer.pivot.set(315 / 2, 360 / 2)
